import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

// Function to submit contact form data
export const submitContactForm = async (formData) => {
  try {
    const docRef = await addDoc(collection(db, 'customer_inquiries'), {
      customerName: formData.name,
      emailAddress: formData.email,
      phoneNumber: formData.phone,
      inquirySubject: formData.subject,
      messageContent: formData.message,
      submissionDate: serverTimestamp(),
      inquiryStatus: 'new',
      inquirySource: 'website_contact_form',
      businessType: 'general_inquiry',
      followUpRequired: true,
      assignedTo: null,
      responseDate: null,
      priority: 'medium'
    });
    
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error submitting contact form:', error);
    return { success: false, error: error.message };
  }
};

// Function to submit brochure download lead form
export const submitBrochureRequest = async (formData) => {
  try {
    const docRef = await addDoc(collection(db, 'brochure_leads'), {
      companyName: formData.companyName,
      contactPersonName: formData.contactPerson,
      businessEmail: formData.email,
      contactNumber: formData.phone,
      additionalMessage: formData.message,
      submissionDate: serverTimestamp(),
      leadStatus: 'new',
      leadSource: 'website_brochure_download',
      brochureType: 'complete_catalog',
      followUpScheduled: false,
      leadScore: 'hot',
      businessCategory: 'corporate_gifting',
      estimatedBudget: null,
      expectedOrderDate: null
    });
    
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error submitting brochure request:', error);
    return { success: false, error: error.message };
  }
};

// Function to submit newsletter subscription
export const submitNewsletter = async (email) => {
  try {
    const docRef = await addDoc(collection(db, 'email_subscribers'), {
      subscriberEmail: email,
      subscriptionDate: serverTimestamp(),
      subscriptionStatus: 'active',
      subscriptionSource: 'website_newsletter',
      emailPreferences: ['product_updates', 'special_offers', 'festival_collections'],
      unsubscribedDate: null,
      bounceCount: 0,
      lastEmailSent: null,
      subscriberSegment: 'general'
    });
    
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error submitting newsletter subscription:', error);
    return { success: false, error: error.message };
  }
};

// Function to submit custom quote request
export const submitQuoteRequest = async (quoteData) => {
  try {
    const docRef = await addDoc(collection(db, 'quote_requests'), {
      customerName: quoteData.customerName || '',
      companyName: quoteData.companyName || '',
      emailAddress: quoteData.email || '',
      phoneNumber: quoteData.phone || '',
      giftCategory: quoteData.category || '',
      orderQuantity: quoteData.quantity || '',
      budgetRange: quoteData.budget || '',
      deliveryTimeline: quoteData.deliveryDate || '',
      customRequirements: quoteData.requirements || '',
      occasionType: quoteData.occasion || '',
      submissionDate: serverTimestamp(),
      quoteStatus: 'pending',
      requestSource: 'website_quote_form',
      assignedSalesRep: null,
      quotePreparedDate: null,
      quoteAmount: null,
      quoteValidUntil: null,
      orderConfirmed: false,
      priority: 'high',
      followUpRequired: true
    });
    
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error submitting quote request:', error);
    return { success: false, error: error.message };
  }
};

// Function to track website analytics
export const trackWebsiteAnalytics = async (analyticsData) => {
  try {
    const docRef = await addDoc(collection(db, 'website_analytics'), {
      pageVisited: analyticsData.page,
      visitTimestamp: serverTimestamp(),
      userAgent: navigator.userAgent,
      referrerUrl: document.referrer,
      sessionDuration: analyticsData.sessionDuration,
      deviceType: analyticsData.deviceType,
      browserName: analyticsData.browser,
      countryCode: analyticsData.country,
      cityName: analyticsData.city,
      pageLoadTime: analyticsData.loadTime,
      userInteractions: analyticsData.interactions || []
    });
    
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error tracking analytics:', error);
    return { success: false, error: error.message };
  }
};

// Function to submit product inquiry
export const submitProductInquiry = async (productData) => {
  try {
    const docRef = await addDoc(collection(db, 'product_inquiries'), {
      productName: productData.productName,
      productCategory: productData.category,
      customerName: productData.customerName,
      emailAddress: productData.email,
      phoneNumber: productData.phone,
      quantityRequired: productData.quantity,
      customizationNeeded: productData.customization,
      inquiryMessage: productData.message,
      submissionDate: serverTimestamp(),
      inquiryStatus: 'new',
      inquirySource: 'website_product_page',
      productPrice: productData.price,
      deliveryLocation: productData.location,
      urgencyLevel: productData.urgency || 'normal',
      followUpCompleted: false
    });
    
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error submitting product inquiry:', error);
    return { success: false, error: error.message };
  }
};
